import { useMutation } from "@apollo/client/react";import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomButton } from '../../../../components/customButton/CustomButton';

import UPDATE_RESPONSALBE_AREA from '../../../../data/graphQL/mutations/Reclamo/UpdateResponsableArea';
import toast from 'react-hot-toast';

export default function TabResponsableArea({
  idGestionReclamo,
  onChange,
  reclamoFormData,
  editable
}) {

  const [selectedActions, setSelectedActions] = useState([]);

  const [guardarDatos, { loading: guardarLoading }] = useMutation(UPDATE_RESPONSALBE_AREA, {
    variables: {
      idGestionReclamo: idGestionReclamo,
      input: {
        investigacion: reclamoFormData?.stage3?.investigacion,
        capa: !!reclamoFormData?.stage3?.capa,
        accionTomada: reclamoFormData?.stage3?.accionTomada
      }
    },
    onCompleted: () => {
      toast.success('Los datos de la etapa Responsable de área ha sido guardada!');
    }
  });

  const handleInputChange = useCallback((fieldName, value) => {
    onChange({
      [fieldName]: value
    });
  }, []);

  const updatedInputs = useMemo(() => {
    return structuredClone(inputs).map((input) => {
      const updatedInput = { ...input };

      if (!editable) {
        updatedInput.disabled = true;
      }
      return updatedInput;
    });
  }, [editable]);

  useEffect(() => {
    if (!reclamoFormData?.stage3?.accionTomada?.length) {
      onClickAgregarAccion();
    }
  }, [reclamoFormData?.stage3?.accionTomada]);

  const onClickAgregarAccion = () => {
    handleInputChange('accionTomada', [
    ...(reclamoFormData?.stage3?.accionTomada ?? []),
    '']
    );
  };

  const handleChangeAccionTomada = (value, index) => {
    const updatedAcciones = reclamoFormData?.stage3?.accionTomada?.map((accion, idx) =>
    idx === index ? value : accion
    ) || [];

    handleInputChange('accionTomada', updatedAcciones);
  };
  const validData = () => {
    const errorMessages = [];

    if (!reclamoFormData?.stage3?.investigacion?.trim()) {
      errorMessages.push('Debe ingresar un valor para Investigación.\n');
    }
    if (!reclamoFormData?.stage3?.accionTomada?.length) {
      errorMessages.push('Debe ingresar al menos una Acción tomada.\n');
    }
    if (!reclamoFormData?.stage3?.accionTomada?.every((x) => !!x?.trim())) {
      errorMessages.push('Las acciones tomadas no pueden estar vacías.\n');
    }
    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const onSave = () => {
    if (!validData()) return;
    guardarDatos();
  };

  const handleCheck = (accionIndex) => {
    setSelectedActions((prev) => {
      if (prev.includes(accionIndex)) {
        return prev.filter((item) => item !== accionIndex);
      } else {
        return [...prev, accionIndex];
      }
    });
  };

  const onClickEliminar = () => {
    const updatedAcciones = reclamoFormData?.stage3?.accionTomada?.filter((accion, index) =>
    !selectedActions.includes(index)
    ) || [];

    handleInputChange('accionTomada', updatedAcciones);

    setSelectedActions([]);
  };

  return (
    <div>
            <Grid container spacing={2}>
                {updatedInputs.map((input) =>
        <Grid key={`input-${input.name}-${input.displayName}`} size={{ xs: input.col }}>
                        <RenderInputByTypeMobile
            input={input}
            handleChange={handleInputChange}
            value={reclamoFormData?.stage3[input.name]} />
          
                    </Grid>
        )}
                {reclamoFormData?.stage3?.accionTomada?.map((accion, accionIndex) =>
        <Grid key={`input-${accionIndex}`} size={{ xs: 12 }}>
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                            <FormControlLabel
              sx={{ margin: 0, height: 24 }}
              disabled={!editable || reclamoFormData?.stage3?.accionTomada.length <= 1}
              onChange={(e) => handleCheck(accionIndex)}
              control={<Checkbox checked={selectedActions.includes(accionIndex)} />} />
            
                            <RenderInputByTypeMobile
              input={{
                displayName: `Acción tomada ${accionIndex > 0 ? '(' + (accionIndex + 1) + ')' : ''}`,
                name: 'accionTomada',
                type: 'long_string',
                disabled: !editable,
                required: true
              }}
              handleChange={(_, value) => handleChangeAccionTomada(value, accionIndex)}
              value={accion} />
            
                        </Box>
                    </Grid>
        )}
                {editable && <>
 <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <CustomButton
                label='Eliminar selección'
                variant='outlined'
                onClick={onClickEliminar}
                disabled={selectedActions.length === 0} />
              
                            <CustomButton
                label='Agregar acción'
                variant='outlined'
                onClick={onClickAgregarAccion}
                sx={{ ml: 1 }} />
              
                        </Box>
                    </Grid>
 <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <CustomButton
                label='Guardar Datos'
                variant='contained'
                onClick={onSave}
                disabled={guardarLoading} />
              
                        </Box>
                    </Grid>
                </>}
            </Grid>

        </div>);

}
const inputs = [
//row
{
  name: 'investigacion',
  displayName: 'Investigación',
  type: 'long_string',
  disabled: false,
  required: true,
  col: 12
},
{
  name: 'capa',
  displayName: `CAPA's`,
  type: 'custom_switch',
  disabled: false,
  col: 12
}];